import { render, staticRenderFns } from "./PrenotazioniPaziente.vue?vue&type=template&id=622d4598&"
import script from "./PrenotazioniPaziente.vue?vue&type=script&lang=js&"
export * from "./PrenotazioniPaziente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports